import axios from 'axios'
import { API_BASE_URL } from '../config/api'
import { useAsyncQuery } from './useAsyncQuery'

export const useStats = () => {
  const fetchStats = async () => {
    const response = await axios.get(`${API_BASE_URL}/api/events/stats`, {
      withCredentials: true
    })
    return response.data
  }

  // Every array is defaulted so the sections render an empty state on the first
  // paint instead of throwing on `.map` of undefined.
  const initialStats = {
    totalDays: 0,
    totalEvents: 0,
    eventsByType: {},
    allArtists: [],
    headlines: {},
    artistHistory: [],
    favoriteArtists: [],
    missedArtists: [],
    discoveries: [],
    venues: [],
    places: [],
    eventsByYear: [],
    lineupCoverage: {},
    genres: [],
    deep: {}
  }

  const { data: stats, loading, error, refetch } = useAsyncQuery(
    fetchStats,
    [],
    { initialData: initialStats }
  )

  return { stats, loading, error, refetch }
}
